import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import 'date-fns'
import Context from '../../context'
import EventDateList from '../EventDateList'
import TextAreaHtml from '../TextAreaHtml'

function EventInfo({ checkValue, checkIsRed }) {
  const { formObject, setFormObject } = useContext(Context)

  const handleTextArea = value => {
    setFormObject({ ...formObject, roles: value })
    checkValue('roles', value)
  }

  return (
    <>
      <h5>Informações de Desconto</h5>
      <div className="row">
        <TextAreaHtml
          handleEditor={handleTextArea}
          placeholder="Informações sobre as regras de descontos."
          value={formObject.roles}
          checkIsRed={checkIsRed}
          strToCheckIsRed="roles"
        />
        <div className="form-group col-md-6">
          <div className="input-group">
            <input
              type="number"
              className="form-control"
              placeholder="Percentagem do Desconto"
              value={formObject.discountAmount}
              onChange={e => {
                setFormObject({
                  ...formObject,
                  discountAmount: e.target.value
                })
              }}
            />
            <div className="input-group-append">
              <span className="input-group-text">%</span>
            </div>
          </div>
        </div>

        <div className="form-group col-3">
          <div className="form-check form-group">
            <input
              className="form-check-input"
              type="checkbox"
              id="hasCourtesy"
              checked={formObject.hasCourtesy}
              onChange={() => {
                setFormObject({
                  ...formObject,
                  hasCourtesy: !formObject.hasCourtesy
                })
              }}
            />
            <label htmlFor="hasCourtesy" className="form-check-label">
              Possui Cortesia para Sorteio
            </label>
          </div>
        </div>
        {formObject.hasCourtesy && (
          <div className="form-group col-3">
            <input
              type="number"
              className="form-control"
              placeholder="Qtd. de cortesias"
              value={formObject.amountOfCourtesies}
              onChange={e => {
                setFormObject({
                  ...formObject,
                  amountOfCourtesies: e.target.value
                })
              }}
            />
          </div>
        )}
        <EventDateList />
      </div>
    </>
  )
}

EventInfo.defaultProps = {
  checkValue: () => {},
  checkIsRed: () => {}
}

EventInfo.propTypes = {
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default EventInfo
